import React from "react";
import Select from "../select";
import { equipmentColumns } from "../../../constants/columns/calculations/equipmentTable";
import { Equipment } from "../../../store/model/calculations/calculation";
import useProtectorFacade from "../../../facade/calculation/calculation-output/protector.facade";
import { usePumpFacade } from "../../../facade/calculation/calculation-output/pump.facade";
import { useGasCalculationFacade } from "../../../facade/calculation/calculation-output/gasCalculation.facade";
import useCableFacade from "../../../facade/calculation/calculation-output/cable.facade";
import useSchematicFacade from "../../../facade/calculation/calculation-output/schematic.facade";
import { useAppSelector } from "../../../store/hooks/StoreHooks";

interface EquipmentTableAddChargePumpInterface {
  onClear?: any;
  options?: any;
  onChange?: any;
  equipments?: any[];
  rowLength: number;
  columns?: any[];
  equipmentGridParentContainer?: string;
  parentId?: string;
  selectedPumpEquipments?: any[];
  selectedChargePumpCount?: number;
  details?: any[];
  isPumpListMode?: boolean;
  isMotorListMode?: boolean;
  isMotorListSensorMode?: boolean;
  parentRef?: React.RefObject<HTMLElement>
  styles?: { [key: string]: any };
}

const EquipmentTableAddChargePump: React.FC<
  EquipmentTableAddChargePumpInterface
> = ({
  onClear,
  options,
  onChange,
  equipments = [],
  rowLength,
  columns = equipmentColumns,
  equipmentGridParentContainer,
  selectedPumpEquipments,
  selectedChargePumpCount,
  parentId,
  details,
  isPumpListMode,
  isMotorListMode = false,
  isMotorListSensorMode = false,
  parentRef,
  styles
}) => {

    const { updateTypeOfShaft, updateSelectedTypeOfShaft1, updateSelectedTypeOfShaft2, updateSelectedTypeOfShaft3 } = useGasCalculationFacade();
    const { updateSelectedUpperEquipment, updateSelectedLowerEquipment } =
      useProtectorFacade();
    const { updateESPEquipmentsForPumps, updateESPEquipmentsForBOH } =
      usePumpFacade();
    const { updateSelectedWellEquipment, updateSelectedLockPlateEquipment } = useCableFacade();
  const { updateESPEquipmentsForBelowESP } = useSchematicFacade();

    const removeEquipmentsFromMainPump = () => {
      if (
        selectedPumpEquipments?.length &&
        selectedChargePumpCount !== undefined &&
        ((selectedPumpEquipments?.length === 7 && selectedChargePumpCount === 1) ||
          (selectedPumpEquipments?.length === 6 &&
            selectedChargePumpCount === 2) ||
          (selectedPumpEquipments?.length === 5 && selectedChargePumpCount === 3))
      ) {
        const equipmentCopy = [...selectedPumpEquipments];
        const updatedPumpEquipment = equipmentCopy.slice(0, -1);
        const shaftType =
          updatedPumpEquipment[updatedPumpEquipment?.length - 1]?.shaftType ===
            "STD"
            ? 0
            : 1;
        // tubingFacade.Sethdn_Pump_ShaftType(shaftType.toString());
        // pumpFacade.SetESPEquipments(equipmentCopy.slice(0, -1));
      }
    };

    const setESPEquipments = (equipments: Equipment[]) => {
      let updatedEquipments = equipments.map((equipment) => ({
        ...equipment,
        label: equipment?.pN_Description || equipment?.boh || equipment?.accBelowESP || equipment?.mle,
        value: equipment?.id,
        equipmentName: equipment?.pN_Description,
        pn: equipment?.pn,
        parentId: parentId,
        equipmentId: equipment?.id,
        configuration: equipment?.configuration,
        diameter:
          equipmentGridParentContainer === "SRMLE"
            ? equipment?.dimension
            : equipment?.od?.toString() ?? equipment?.diameter,
        shaftType: equipment?.shaftType,
      }));
      switch (equipmentGridParentContainer) {
        // case "SRPumps":
        //   updateESPEquipmentsForPumps([...updatedEquipments]);
        //   break;
        case "SRProtectors":
          const equipmentDetails = equipments?.find(
            (x) => x.id === updatedEquipments[0]?.id
          );
          if (equipmentDetails) {
            updatedEquipments[0].length = equipmentDetails?.length ?? 0;
            updatedEquipments[0].weight = equipmentDetails?.weight ?? 0;
          }
          updateSelectedLowerEquipment(updatedEquipments);
          break;
        case "SRProtectorsUpper":
          const equipmentUpperDetails = equipments?.find(
            (x) => x.id === updatedEquipments[0]?.id
          );
          if (equipmentUpperDetails) {
            updatedEquipments[0].length = equipmentUpperDetails?.length ?? 0;
            updatedEquipments[0].weight = equipmentUpperDetails?.weight ?? 0;
          }
          updateSelectedUpperEquipment(updatedEquipments);
          break;
        case "SRMotorSensor":
          // tubingFacade.SethdnMotorSensor(+updatedEquipments[0]?.id)
          // motorFacade.SetESPEquipmentsForSensor(updatedEquipments);
          break;
        case "SRChargePump1":
          if (updatedEquipments.length === 1) {
            removeEquipmentsFromMainPump();
          }
          // gasFacade.SetESPEquipmentsForChargePumpOne(updatedEquipments);
          break;
        case "SRChargePump2":
          if (updatedEquipments.length === 1) {
            removeEquipmentsFromMainPump();
          }
          // gasFacade.SetESPEquipmentsForChargePumpTwo(updatedEquipments);
          break;
        case "SRChargePump3":
          if (updatedEquipments.length === 1) {
            removeEquipmentsFromMainPump();
          }
          // gasFacade.SetESPEquipmentsForChargePumpThree(updatedEquipments);
          break;
        case "SRAccBelowESP":
          updateESPEquipmentsForBelowESP([...updatedEquipments]);
          break;
        case "SRCablesWell":
        // let value = [...updatedEquipments];
        // let cableLength = selectedLowerEquipment?.length > 0 ? selectedLowerEquipment?.[0]?.setDepth : schematicData?.setDepth;
        // const updatedCableEquipments = value?.map(equipment => ({
        //   ...equipment,
        //   length: cableLength,
        //   totalLength: cableLength,
        //   dimensions: equipment.dimensions,
        //   nominalWeight: parseFloat(((cableLength * parseFloat((equipment?.nominalWeight || 0).toFixed(2))).toFixed(2)))
        // }));
        // value = [...updatedCableEquipments];

        // updateSelectedWellEquipment(value);
        // break;
        case "SRSurfaceEquipments":
          // surfaceFacade.SetESPEquipments(updatedEquipments);
          break;
        case "SRMotorList":
          // motorFacade.SetESPEquipments(updatedEquipments);
          break;
        case "SRBOH":
          updateESPEquipmentsForBOH([...updatedEquipments]);
          break;
        case "SRMLE":
          updateSelectedLockPlateEquipment(updatedEquipments);
          break;
      }
    };

    const handleEquipmentChange = (rows: any, rowIndex: any) => {
      if (!rows?.value) return;
      const equipment = options?.find((x: any) => x.id === rows?.value);
      if (equipment) {
        const updatedDetails = equipments?.map((detail, index) =>
          index === rowIndex ? { ...detail, ...equipment } : detail
        );
        details = updatedDetails;
        if (equipmentGridParentContainer === 'SRGasHandlers') {
          const shaftTypeValue = details[0]?.shaftType === 'STD' ? 1 : 0;
          updateTypeOfShaft(shaftTypeValue);
        }
        if (equipmentGridParentContainer === 'SRChargePump1') {
          const shaftType = details[0]?.shaftType === 'STD' ? 1 : 0;
          updateSelectedTypeOfShaft1(shaftType);
        }
        if (equipmentGridParentContainer === 'SRChargePump2') {
          const shaftType = details[0]?.shaftType === 'STD' ? 1 : 0;
          updateSelectedTypeOfShaft2(shaftType);
        }
        if (equipmentGridParentContainer === 'SRChargePump3') {
          const shaftType = details[0]?.shaftType === 'STD' ? 1 : 0;
          updateSelectedTypeOfShaft3(shaftType);
        }
        const filteredDetails: any = details
          ?.filter((x) => x.id !== "" && x.id !== null)
          .map((detail) => ({ ...detail }));
        setESPEquipments(filteredDetails);
      }
      onChange && onChange(rows, rowIndex);

    };

    const onClearDropdown = (id: String, index: number) => {
      onClear && onClear(id, index);
    };

    const renderTableHeader = () => {
      return (
        <thead>
          <tr>
            <th className='px-[24px] py-[16px] text-[12px] text-neutral-25 w-[40%]'>
              <div className='flex items-center'>
                <span className='text-[14px] font-semibold'>Equipments</span>
              </div>
            </th>
            {columns &&
              columns?.map((col) => (
                <th className='px-[24px] py-[16px] text-[12px] text-neutral-25 w-[15%]'>
                  <div className='flex items-center' key={col?.key}>
                    <span className='text-[14px] font-semibold'>
                      {col?.title}
                    </span>
                  </div>
                </th>
              ))}
          </tr>
        </thead>
      );
    };

    const renderTableBody = () => {
      return (
        <tbody>
          {equipments &&
            equipments.length <= rowLength &&
            equipments.map((row, rowIndex) => {
              const dropdownOptions = isPumpListMode
                ? options?.[rowIndex]?.equipments?.map((item: any) => ({
                  ...item,
                  label: item?.pN_Description,
                  value: item?.id,
                })) ?? []
                :
                isMotorListMode ?
                  (() => {
                    if (rowIndex === 0) {
                      return options?.length ? options.filter((x: any) => ['UT', 'SINGLE'].includes(x.configuration)) : [];
                    } 
                    else if (rowIndex > 0) {
                      return options?.length ? options.filter((x: any) => ['CT', 'LT'].includes(x.configuration)) : [];
                    }
                    
                    else {
                      return options?.length ? options.filter((x: any) => x.configuration != 'UT') : [];
                    }
                  })()
                  :
                  Array.isArray(options) ? options : [];

              const selectedValue = row?.value;
              const hasSelection = isPumpListMode
                ? row?.id &&
                  options &&
                  options?.[options.length - 1].equipments?.some(
                    (opt: any) => opt.id === row.id
                  )
                : row?.id && options?.some((opt: any) => opt.id == row.id);         


              return (
              
                <tr key={rowIndex}>
                  <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                    <Select
                      styles={styles}
                      options={dropdownOptions}
                      onChange={(selected) => handleEquipmentChange(selected, rowIndex)}
                      padding="px-[14px] py-[5px]"
                      fontSize="16px"
                      className="sm:px-0 px-[10px] flex-wrap break-all !static"
                      selectedValue={selectedValue}
                      onClear={() => onClearDropdown(row?.id, rowIndex)}
                      showCloseIcon={!!row?.label}
                      width="100%"
                      isWrap
                      parentRef={parentRef}
                      dropdownDirection={isMotorListSensorMode ? "up" : "down"}
                    />
                  </td>
                  {columns &&
                    columns.map((col, colIndex) => (
                      <td
                        className="px-[24px] py-[9px] text-neutral-25 text-[14px] w-[15%]"
                        key={colIndex}
                      >
                        {hasSelection || isPumpListMode ? (row[col?.key] ?? "--") : "--"}
                      </td>
                    ))}
                </tr>
              );
            })}

        </tbody>
      );
    };


    return (
      <div className='scrollable w-full over'>
        <table className='min-w-full rounded-[8px] outline-[1px] table overflow-x-auto'>
          {renderTableHeader()}
          {renderTableBody()}
        </table>
      </div>
    );
  };

export default EquipmentTableAddChargePump;
